import { array, object, string } from 'yup'
import { PLAN_NAME_MAX_LENGTH } from '../constants'

/** Validation of the "Erstellen" form (`PlanViewCreateSection`). */
export const newPlanSchema = object({
  name: string()
    .trim()
    .required('Bitte einen Plannamen eingeben')
    .max(PLAN_NAME_MAX_LENGTH, `Maximal ${PLAN_NAME_MAX_LENGTH} Zeichen`),
  comment: string(),
  tags: array(string().required()),
})
